
import { computed, defineComponent } from "vue";
import { useStore } from "vuex";
import TimerCircle from "./TimerRadial.vue";
import TimerBar from "./TimerBar.vue";
import AppIcon from "@/components/AppIcon.vue";
import GameMetaData from "@/components/Games/GameMetaData.vue";

import { mdiCheck } from "@mdi/js";

export default defineComponent({
  setup() {
    const store = useStore();
    return {
      word: computed(() => store.getters.getWord),
      playerFoundAnswer: computed(() => store.getters.getPlayerFoundAnswer),
      mdiCheck,
      currentRound: computed(() => store.getters.getCurrentRound),
      roundCount: computed(() => store.getters.getRoundCount),
      remainingTime: computed(() => store.getters.getCurrentTime),
    };
  },
  components: {
    TimerCircle,
    TimerBar,
    AppIcon,
    GameMetaData,
  },
});
